// Local calendar dates as YYYY-MM-DD.
// new Date().toISOString() is UTC and shifts the calendar day after ~5pm in US timezones.
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
